// Single source of truth for course certificates shown in the Certificates
// section. `image` is the rendered first page of the matching PDF kept in
// public/certificates/; `href` is Coursera's live verification page.
import pythonCert from "../images/certificates/crash-course-on-python.jpg";
import googleAdsCert from "../images/certificates/google-ads-search-campaign.jpg";
import wordpressCert from "../images/certificates/wordpress-website.jpg";

export const CERTIFICATES = [
  {
    key: "python",
    title: "Crash Course on Python",
    issuer: "Google",
    date: "Jun 2022",
    image: pythonCert,
    pdf: "/certificates/crash-course-on-python.pdf",
    href: "https://coursera.org/verify/67SHU9S7SWWF",
  },
  {
    key: "google-ads",
    title: "Create a Google Ads Search Campaign",
    issuer: "Coursera Project Network",
    date: "Apr 2022",
    image: googleAdsCert,
    pdf: "/certificates/google-ads-search-campaign.pdf",
    href: "https://coursera.org/verify/5E9F99EPH3WB",
  },
  {
    key: "wordpress",
    title: "Create a Website Using WordPress",
    issuer: "Coursera Project Network",
    date: "Jan 2022",
    image: wordpressCert,
    pdf: "/certificates/wordpress-website.pdf",
    href: "https://coursera.org/verify/F4M7TXXPC5H2",
  },
];
